import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Instagram, Mail, Linkedin, Menu, X } from 'lucide-react';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const isHomePage = location.pathname === '/';

  const handleNavClick = (e, sectionId) => {
    e.preventDefault();
    setIsOpen(false);
    
    if (isHomePage) {
      // Si estamos en home, hacer scroll
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // Si estamos en otra página, ir a home y luego al section
      navigate('/', { state: { scrollTo: sectionId } });
    }
  };

  // Efecto para scroll después de navegar
  React.useEffect(() => {
    if (location.state?.scrollTo) {
      setTimeout(() => {
        const element = document.getElementById(location.state.scrollTo);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  }, [location.state]);

  return (
    <nav
      className="fixed top-0 w-full backdrop-blur-sm z-50 border-b shadow-sm"
      style={{ backgroundColor: 'rgba(255,253,235,0.93)', borderColor: 'rgba(74,21,75,0.1)' }}
    >
      <style>{`
        .tg-nav-link { color: #4A154B; transition: color 0.2s ease; }
        .tg-nav-link:hover { color: #F4A1C8 !important; }
        .tg-cta-btn {
          color: #4A154B !important;
          background-color: #F4A1C8 !important;
          transition: background-color 0.2s ease;
        }
        .tg-cta-btn:hover { background-color: #e882ad !important; }
      `}</style>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-end h-24">

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <Link to="/" className="text-sm font-medium tg-nav-link">
              INICIO
            </Link>
            <a
              href="#quienes-somos"
              onClick={(e) => handleNavClick(e, 'quienes-somos')}
              className="text-sm font-medium tg-nav-link cursor-pointer"
            >
              QUIÉNES SOMOS
            </a>
            <a
              href="#talentos"
              onClick={(e) => handleNavClick(e, 'talentos')}
              className="text-sm font-medium tg-nav-link cursor-pointer"
            >
              TALENTOS
            </a>
            <a
              href="#contacto"
              onClick={(e) => handleNavClick(e, 'contacto')}
              className="text-sm font-bold cursor-pointer px-4 py-2 rounded-lg tg-cta-btn"
            >
              CONTACTO
            </a>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden transition-colors"
            style={{ color: '#4A154B' }}
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isOpen && (
        <div className="md:hidden border-t" style={{ backgroundColor: '#FFFDEB', borderColor: 'rgba(74,21,75,0.1)' }}>
          <div className="px-4 pt-4 pb-6 space-y-4">
            <Link
              to="/"
              onClick={() => setIsOpen(false)}
              className="block text-sm font-medium tg-nav-link"
            >
              INICIO
            </Link>
            <a
              href="#quienes-somos"
              onClick={(e) => handleNavClick(e, 'quienes-somos')}
              className="block text-sm font-medium tg-nav-link cursor-pointer"
            >
              QUIÉNES SOMOS
            </a>
            <a
              href="#talentos"
              onClick={(e) => handleNavClick(e, 'talentos')}
              className="block text-sm font-medium tg-nav-link cursor-pointer"
            >
              TALENTOS
            </a>
            <a
              href="#contacto"
              onClick={(e) => handleNavClick(e, 'contacto')}
              className="block text-sm font-bold cursor-pointer px-4 py-2 rounded-lg text-center tg-cta-btn"
            >
              CONTACTO
            </a>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
